import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@/routes/utils";

const baseRoute = `/user-management/teacher`;

export const teachersRoutesObj = {
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:teacherId`,
} as const;

export type ITeachersRouteParams = IExtractRouteParamMap<
  typeof teachersRoutesObj
>;

export const teachersPath = createPaths<
  typeof teachersRoutesObj,
  ITeachersRouteParams
>(teachersRoutesObj);
